import { Dispatch, Action } from 'redux'
import { UserReportMainMapDispatchReturnType } from './types/UserReportMainMapDispatchReturnType'

export const UserReportMainMapDispatch = (
  _dispatch: Dispatch<Action>
): UserReportMainMapDispatchReturnType => {
  return {
  }
}
